module.exports = __webpack_public_path__ + "static/img/co-operate-02.0d44923.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/co-operate-02.png
// module id = KPnR
// module chunks = 1